import format from 'date-fns/format';
import moment from 'moment';

export const formatDisplayDate = (startDate, endDate) => {
  const dateFormat = 'D MMM YYYY';
  let formattedDates = '';
  if (startDate && endDate) {
    formattedDates = `${format(startDate, dateFormat)
    } - ${format(endDate, dateFormat)}`;
  }
  return formattedDates;
};

export const formatDate = (date) => {
  const dateFormat = 'YYYY-MM-DD';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatDisplaySingleDate = (date) => {
  const dateFormat = 'D MMM YYYY';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const formatCommentDate = (date) => {
  const dateFormat = 'MMM DD | hh:mm A';
  let formattedDate = '';
  if (date) {
    formattedDate = format(date, dateFormat);
  }
  return formattedDate;
};

export const getDateDiff = (date1, date2) => {
  const value = moment(date1).startOf('day').diff(moment(date2).startOf('day'), 'days');
  return value;
};
